var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.color === 'red')?_c('img',{attrs:{"src":require("@/assets/images/car-red.png")}}):(_vm.color === 'blue')?_c('img',{attrs:{"src":require("@/assets/images/car-blue.png")}}):(_vm.color === 'green')?_c('img',{attrs:{"src":require("@/assets/images/car-green.png")}}):_c('div',[_vm._v(".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }